export function hrefReplace(text: string): string {
    // const RexpWww = /((?<!\/)www[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g;
    const regexpWwwStartString = /^(www[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g;

    let content = text ? text.replace(regexpWwwStartString, '\nhttps://$1') : '';

    const regexpWwwStartBrake = /\>(www[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g;

    content = content.replace(regexpWwwStartBrake, '>https://$1');

    const regexpWwwStartSpace = /\s(www[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g;

    content = content.replace(regexpWwwStartSpace, ' https://$1');

    const regexpHttp = /((?<!(\=\"|\"\>|\=\'|\'\>))((http|https|ftp):\/\/)[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g;

    return content.replace(regexpHttp, '<a href="$1" target="_blank" class="h-link">$1</a>');
}
